import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Home/Hero';
import { Carousel } from '../components/Home/Carousel';
import { Stats } from '../components/Home/Stats';
import { SuccessStories } from '../components/Home/SuccessStories';
import { Newsletter } from '../components/Home/Newsletter';
import { MembershipBenefits } from '../components/Home/MembershipBenefits';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
import { ServicePillars } from '../components/Home/ServicePillars';
import { SlidingGallery } from '../components/Home/SlidingGallery';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
import { initScrollAnimations, ANIMATION_CLASSES } from '../utils/animations';
interface HomeProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Home = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: HomeProps) => {
  const accessPointsRef = useRef<HTMLDivElement>(null);
  // Initialize ALL scroll animations (handles scroll-animate, scroll-animate-left, scroll-animate-right, scroll-animate-scale)
  useEffect(() => {
    const observer = initScrollAnimations();
    return () => observer?.disconnect();
  }, []);
  const scrollToAccessPoints = () => {
    if (accessPointsRef.current) {
      accessPointsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const openCorporateTrainingForm = () => {
    if ((window as any).openCorporateTrainingForm) {
      ;
      (window as any).openCorporateTrainingForm();
    }
  };
  const carouselImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    alt: 'The Networking Salon group photo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    alt: 'Five women at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    alt: 'Four people at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    alt: 'The Networking Salon event'
  }];
  return <main className="overflow-hidden" data-id="element-3212">
      <Hero openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-3213" />

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-white" data-id="element-3214">
        <div className="container mx-auto px-4" data-id="element-3215">
          <div className="max-w-4xl mx-auto text-center mb-12 scroll-animate" data-id="element-3216">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-3217">
              Welcome to The Networking Salon
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-3218">
              A community dedicated to connecting professionals, fostering
              growth, and creating opportunities.
            </p>
          </div>

          <div className="scroll-animate-scale" style={{
          transitionDelay: '200ms'
        }} data-id="element-3219">
            <Carousel images={carouselImages} data-id="element-3220" />
          </div>
        </div>
      </section>

      {/* Animated section divider */}
      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3221"></div>

      <div className="scroll-animate-left" data-id="element-3222">
        <ServicePillars data-id="element-3223" />
      </div>

      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3224"></div>

      <div className="scroll-animate-scale" data-id="element-3225">
        <Stats data-id="element-3226" />
      </div>

      <div className="scroll-animate-right" data-id="element-3227">
        <SlidingGallery data-id="element-3228" />
      </div>

      <div className="section-reveal-line scroll-animate mx-auto max-w-4xl" data-id="element-3229"></div>

      <div className="scroll-animate-left" data-id="element-3230">
        <SuccessStories data-id="element-3231" />
      </div>

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-gray-50" data-id="element-3232">
        <div className="container mx-auto px-4" data-id="element-3233">
          <div className="text-center mb-12 scroll-animate" data-id="element-3234">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-primary" data-id="element-3235">
              Ready to Get Started?
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-3236">
              Join our community, partner with us, or explore our services to
              take your professional journey to the next level.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 scroll-animate-scale" style={{
          transitionDelay: '200ms'
        }} data-id="element-3237">
            <Button onClick={scrollToAccessPoints} className="w-full md:w-auto shadow-lg" size="lg" data-id="element-3238">
              Join the Salon
            </Button>

            <Link to="/host-salon" className="w-full md:w-auto" data-id="element-3239">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3240">
                Host a Salon
              </Button>
            </Link>

            <Link to="/partner-with-us" className="w-full md:w-auto" data-id="element-3241">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3242">
                Partner with Us
              </Button>
            </Link>

            <Link to="/contact" className="w-full md:w-auto" data-id="element-3243">
              <Button variant="outline" className="w-full bg-white" size="lg" data-id="element-3244">
                Explore Services
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <div ref={accessPointsRef} className="scroll-animate" data-id="element-3245">
        <MembershipBenefits data-id="element-3246" />
        <AccessPoints openPaymentForm={openPaymentForm} openCorporateTrainingForm={openCorporateTrainingForm} data-id="element-3247" />
      </div>

      <div className="scroll-animate-scale" data-id="element-3248">
        <FinalCTA openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-3249" />
      </div>

      <div className="scroll-animate-right" data-id="element-3250">
        <Newsletter data-id="element-3251" />
      </div>
    </main>;
};